import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../baseQuery";

const certificateApi = createApi({
  reducerPath: "certificateApi",
  baseQuery: baseQuery,
  tagTypes: ["Certificate"],

  endpoints: (builder) => ({
    createCertificate: builder.mutation<Certificate, { employee_id: number; type_id: number; filename: string }>({
      query: (data) => ({
        url: "/api/certificate",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Certificate"],
    }),

    deleteCertificate: builder.mutation<void, { certificate_id: number }>({
      query: ({ certificate_id }) => ({
        url: `/api/certificate/${certificate_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Certificate"],
    }),
  }),
});

export { certificateApi };

export const { useCreateCertificateMutation, useDeleteCertificateMutation } = certificateApi;
